import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntities } from './bursa-api-bid-cert.reducer';
import { IBursaAPIBidCert } from 'app/shared/model/bursa-api-bid-cert.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const BursaAPIBidCert = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const bursaAPIBidCertList = useAppSelector(state => state.bursaAPIBidCert.entities);
  const loading = useAppSelector(state => state.bursaAPIBidCert.loading);
  const totalItems = useAppSelector(state => state.bursaAPIBidCert.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const { match } = props;

  return (
    <div>
      <h2 id="bursa-api-bid-cert-heading" data-cy="BursaAPIBidCertHeading">
        <Translate contentKey="comexApp.bursaAPIBidCert.home.title">Bursa API Bid Certs</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="primary" outline onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="comexApp.bursaAPIBidCert.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to={`${match.url}/new`} className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="comexApp.bursaAPIBidCert.home.createLabel">Create new Bursa API Bid Cert</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {bursaAPIBidCertList && bursaAPIBidCertList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('endpointURL')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.endpointURL">Endpoint URL</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('ecertNo')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.ecertNo">Ecert No</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('memberShortName')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.memberShortName">Member Short Name</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('successYN')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.successYN">Success YN</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('msg')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.msg">Msg</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('buyer')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.buyer">Buyer</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('owner')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.owner">Owner</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('bidNo')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.bidNo">Bid No</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('totalValue')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.totalValue">Total Value</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('currency')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.currency">Currency</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('price')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.price">Price</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('priceMYR')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.priceMYR">Price MYR</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('purchaseTimeDate')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.purchaseTimeDate">Purchase Time Date</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('valueDate')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.valueDate">Value Date</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('pName')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.pName">P Name</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('pVolume')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.pVolume">P Volume</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('supplier')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.supplier">Supplier</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('volume')}>
                  <Translate contentKey="comexApp.bursaAPIBidCert.volume">Volume</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {bursaAPIBidCertList.map((bursaAPIBidCert, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`${match.url}/${bursaAPIBidCert.id}`} color="link" size="sm">
                      {bursaAPIBidCert.id}
                    </Button>
                  </td>
                  <td>{bursaAPIBidCert.endpointURL}</td>
                  <td>{bursaAPIBidCert.ecertNo}</td>
                  <td>{bursaAPIBidCert.memberShortName}</td>
                  <td>{bursaAPIBidCert.successYN}</td>
                  <td>{bursaAPIBidCert.msg}</td>
                  <td>{bursaAPIBidCert.buyer}</td>
                  <td>{bursaAPIBidCert.owner}</td>
                  <td>{bursaAPIBidCert.bidNo}</td>
                  <td>{bursaAPIBidCert.totalValue}</td>
                  <td>{bursaAPIBidCert.currency}</td>
                  <td>{bursaAPIBidCert.price}</td>
                  <td>{bursaAPIBidCert.priceMYR}</td>
                  <td>{bursaAPIBidCert.purchaseTimeDate}</td>
                  <td>{bursaAPIBidCert.valueDate}</td>
                  <td>{bursaAPIBidCert.pName}</td>
                  <td>{bursaAPIBidCert.pVolume}</td>
                  <td>{bursaAPIBidCert.supplier}</td>
                  <td>{bursaAPIBidCert.volume}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${bursaAPIBidCert.id}`} size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button
                        tag={Link}
                        to={`${match.url}/${bursaAPIBidCert.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      &nbsp;
                      <Button
                        tag={Link}
                        to={`${match.url}/${bursaAPIBidCert.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="comexApp.bursaAPIBidCert.home.notFound">No Bursa API Bid Certs found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={bursaAPIBidCertList && bursaAPIBidCertList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default BursaAPIBidCert;
